import { GlobalState } from '../../reducers';
import { UploadToSdCardState } from './reducers';

const uploadToSdCardSelector = (state: GlobalState): UploadToSdCardState => (
  state.apps.manual.uploadToSdCard
);

export default {
  uploadToSdCardSelector,
};
